<p-panel class="secondary-panel">
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-between align-items-center flex-fill">
      <span>Liabilities</span>
    </div>
  </ng-template>
  <p-table
    #dt
    class="stack-lt-lg"
    dataKey="liabilityId"
    editMode="row"
    [columns]="liabilitiesGridColumns"
    [value]="liabilitiesList$ | async"
    [scrollable]="true"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
            {{ col.header }}
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          <div class="d-flex justify-content-center align-items-center title-text">No records found</div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-editing="editing" let-rowData let-columns="columns" let-ri="rowIndex">
      <tr editing="true" [pEditableRow]="rowData" [ngClass]="{ 'row-selected': editing && +rowData['liabilityId'] === editingId }">
        @for (col of columns; track col) {
          <td [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
            <span class="p-column-title fw-bold">{{ col.header }}</span>
            <div>
              @switch (col.field) {
                @case ('index') {
                  <div>{{ ri + 1 }}</div>
                }
                @case ('liabilityId') {
                  <div style="display: none"></div>
                }
                @case ('applicationId') {
                  <div style="display: none"></div>
                }
                @case ('borrowerId') {
                  <div>
                    <p-cellEditor>
                      @if (Borrower() && Borrower().length === 1) {
                        <ng-template pTemplate="input">
                          {{ rowData[col.field] | toBorrowerName$ | async }}
                        </ng-template>
                      }
                      @if (Borrower() && Borrower().length === 2) {
                        <ng-template pTemplate="input">
                          <p-select
                            class="w-100"
                            [options]="borrowerOptions"
                            [(ngModel)]="rowData[col.field]"
                            [optionLabel]="'value'"
                            [optionValue]="'id'"
                            appendTo="body"
                          />
                        </ng-template>
                      }
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] | toBorrowerName$ | async }}
                      </ng-template>
                      <ng-container />
                    </p-cellEditor>
                  </div>
                }
                @case ('liabilityType') {
                  <div>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-select
                          class="w-100"
                          [options]="liabilityTypes"
                          (onChange)="onChangeLiablityType($event, rowData.applicationId, rowData)"
                          [(ngModel)]="rowData[col.field]"
                          [optionLabel]="'value'"
                          [optionValue]="'id'"
                          appendTo="body"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] | toNameOrValue: liabilityTypes }}
                      </ng-template>
                    </p-cellEditor>
                  </div>
                }
                @case ('accountType') {
                  <div>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-select
                          class="w-100"
                          [options]="bankingLiabilityAccountTypes"
                          [(ngModel)]="rowData[col.field]"
                          [optionLabel]="'value'"
                          [optionValue]="'id'"
                          [disabled]="isOtherLiability"
                          appendTo="body"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container>
                          {{ rowData[col.field] | toNameOrValue: bankingLiabilityAccountTypes }}
                        </ng-container>
                      </ng-template>
                    </p-cellEditor>
                  </div>
                }
                @case ('companyName') {
                  <div>
                    @if (rowData.liabilityType !== 2) {
                      <div>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input
                              [(ngModel)]="rowData[col.field]"
                              styleClass="form-control input-span"
                              class="form-control"
                              pInputText
                              maxlength="50"
                            />
                          </ng-template>
                          <ng-template pTemplate="output">
                            <span>{{ rowData[col.field] }}</span>
                          </ng-template>
                        </p-cellEditor>
                      </div>
                    }
                    @if (rowData.liabilityType === 2) {
                      <div>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-select
                              class="w-100"
                              [options]="expenseTypes"
                              [(ngModel)]="rowData.otherExpenseType"
                              [optionLabel]="'value'"
                              [optionValue]="'id'"
                              appendTo="body"
                            />
                          </ng-template>
                          <ng-template pTemplate="output">
                            <span>{{ rowData.otherExpenseType | toNameOrValue: expenseTypes }}</span>
                          </ng-template>
                        </p-cellEditor>
                      </div>
                    }
                  </div>
                }
                @case ('omitted') {
                  <div>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-selectButton
                          class="primary-toggle"
                          [options]="[
                            { label: 'Yes', value: true },
                            { label: 'No', value: false },
                          ]"
                          [(ngModel)]="rowData[col.field]"
                          optionLabel="label"
                          optionValue="value"
                          [disabled]="isOtherLiability"
                          styleClass="d-flex"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] === true ? 'Yes' : 'No' }}
                      </ng-template>
                    </p-cellEditor>
                  </div>
                }
                @case ('toBePaidOff') {
                  <div>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-selectButton
                          class="primary-toggle"
                          [options]="[
                            { label: 'Yes', value: true },
                            { label: 'No', value: false },
                          ]"
                          [(ngModel)]="rowData[col.field]"
                          optionLabel="label"
                          optionValue="value"
                          [disabled]="isOtherLiability"
                          styleClass="d-flex"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] === true ? 'Yes' : 'No' }}
                      </ng-template>
                    </p-cellEditor>
                  </div>
                }
                @case ('unpaidBalance') {
                  <div>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-inputNumber
                          data-private
                          placeholder="$0.00"
                          currency="USD"
                          mode="currency"
                          [max]="99999999999.99"
                          maxlength="14"
                          locale="en-US"
                          id="unpaidBalance"
                          [(ngModel)]="rowData[col.field]"
                          [disabled]="isOtherLiability"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] | currency | negativeCurrencyToParenthesis }}
                      </ng-template>
                    </p-cellEditor>
                  </div>
                }
                @case ('monthlyPayment') {
                  <div>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-inputNumber
                          data-private
                          placeholder="$0.00"
                          currency="USD"
                          mode="currency"
                          [max]="99999999999.99"
                          locale="en-US"
                          id="defaultPaymentLeft"
                          [(ngModel)]="rowData[col.field]"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] | currency | negativeCurrencyToParenthesis }}
                      </ng-template>
                    </p-cellEditor>
                  </div>
                }
                @case ('defaultPaymentLeft') {
                  <div>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-inputNumber
                          data-private
                          placeholder="$0.00"
                          currency="USD"
                          mode="currency"
                          [max]="99999999999.99"
                          locale="en-US"
                          id="defaultPaymentLeft"
                          [(ngModel)]="rowData[col.field]"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] | number: '1.0-0' }}
                      </ng-template>
                    </p-cellEditor>
                  </div>
                }
                @case ('actionsCol') {
                  <div>
                    <div class="d-flex float-right">
                      <div>
                        <button
                          pButton
                          class="p-button-link"
                          (click)="showPositionDialog('right', ri, rowData)"
                          [disabled]="isFullyDisabled$ | async"
                        >
                          view/edit
                        </button>
                      </div>
                      <div class="me-2 mt-1">
                        @if (!editing) {
                          <p-button
                            pInitEditableRow
                            type="button"
                            (click)="onRowEditInit(ri, rowData)"
                            [disabled]="isFullyDisabled$ | async"
                            icon="pi pi-pencil"
                          />
                        }
                        @if (editing) {
                          <p-button
                            pSaveEditableRow
                            type="button"
                            (click)="onRowEditSave(rowData.applicationId, rowData)"
                            [disabled]="isFullyDisabled$ | async"
                            icon="pi pi-check"
                          />
                        }
                      </div>
                      <div class="mt-1">
                        @if (!editing) {
                          <p-button
                            type="button"
                            severity="danger"
                            data-toggle="tooltip"
                            title="delete"
                            iconPos="left"
                            [disabled]="isFullyDisabled$ | async"
                            (click)="delete(ri, rowData.applicationId, rowData.liabilityId)"
                            icon="pi pi-minus-circle"
                          />
                        }
                        @if (editing) {
                          <p-button
                            pCancelEditableRow
                            severity="danger"
                            type="button"
                            (click)="onRowEditCancel(rowData.applicationId, rowData)"
                            icon="pi pi-trash"
                          />
                        }
                      </div>
                    </div>
                  </div>
                }
                @default {
                  <div>{{ col.field }}: {{ rowData[col.field] }}</div>
                }
              }
            </div>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
  <ng-container>
    <div class="d-flex mt-3">
      <button pButton type="button" severity="secondary" size="small" (click)="onNewClicked()" [disabled]="isFullyDisabled$ | async">
        <i class="pi pi-plus-circle"></i>&nbsp;&nbsp;Add Liability
      </button>
    </div>
  </ng-container>
</p-panel>

<p-dialog
  header="{{ header }} {{ monthlyAmount !== null ? (monthlyAmount | currency) + '/ Month' : '' }}"
  [(visible)]="displayPosition"
  [position]="position"
  [modal]="true"
  [style]="{ height: '100vh', width: '25vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <cmg-liability-details class="d-flex flex-fill flex-column" [selectedLiability]="selectedLiability" (editCancelled)="displayPosition = false" />
</p-dialog>
